import { RouterProvider } from '@tanstack/react-router';
import { apolloClient } from './apollo';
import { router } from './router';

// Create the context shared by all routes in the app
export const Routes = () => <RouterProvider router={router} context={{ apolloClient }} />;
